/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { getLeaseLink, getLeaseListLink } from '../../lib/links/leaseLinks'
import { Divider } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import LeaseTabs from './LeaseTabs'

export type LeaseBreadcrumbProps = {
  lease?: Partial<Lease>,
  title: ReactNode
}

function LeaseBreadcrumb (props: LeaseBreadcrumbProps) {
  const { lease, title } = props
  return (
    <BreadcrumbCard>
      <AdminBreadcrumb>
        <AnchorLink to={getLeaseListLink()}>
          <FormattedMessage
            id="leases"
            defaultMessage="Dossiers de location"
          />
        </AnchorLink>

        {lease?.id != null
          ? <AnchorLink to={getLeaseLink(lease.id)}>
            {lease.reference}
          </AnchorLink>
          : null}

        <span>{title}</span>
      </AdminBreadcrumb>

      {lease?.id > 0
        ? <>
          <Divider my="sm" />
          <LeaseTabs leaseId={lease.id} />
        </>
        : null}
    </BreadcrumbCard>
  )
}

export default LeaseBreadcrumb
